import { OnInit } from '@model/bootstrap/on-init';
import smoothscroll from 'smoothscroll-polyfill';

export class PolyfillBootstrap implements OnInit {
  initialize(): void {
    smoothscroll.polyfill();
  }
}
